import {
  WorksheetBatchUpdateCommonDefaultParams,
  WorksheetBatchUpdateCommonQueryFields,
  WorksheetBatchUpdateCommonRequiredParams,
} from 'Components/WorksheetBatchUpdate/Core/SharedQueryFields';
import { WorksheetBatchUpdateDefinition } from '../..';
import { BsNuclearFieldDensityQueryFields } from './BsNuclearFieldDensityQueryFields';
import {
  BsNuclearFieldDensityWorksheetFields,
  BsNuclearFieldDensityWorksheetSections,
} from './BsNuclearFieldDensityWorksheetFields';

const BsNuclearFieldDensityBatchUpdateDefinition: WorksheetBatchUpdateDefinition = {
  worksheetType: 'Nuclear Field Density',
  query: {
    defaultParams: WorksheetBatchUpdateCommonDefaultParams,
    requiredParams: WorksheetBatchUpdateCommonRequiredParams,
  },
  queryFields: {
    ...WorksheetBatchUpdateCommonQueryFields,
    ...BsNuclearFieldDensityQueryFields,
  },
  worksheetFields: BsNuclearFieldDensityWorksheetFields,
  worksheetFieldSections: BsNuclearFieldDensityWorksheetSections,
};

export default BsNuclearFieldDensityBatchUpdateDefinition;

export { BsNuclearFieldDensityBatchUpdateDefinition };
